const description =
    "Грили и контейнеры MIKU для готовки в микроволновой печи. Термосы, термокувшины, термокружки для заваривания чая и кофе. Покупка в интернет-магазине. Доставка по Казахстану";

export const miKuKzMeta = {
    home: {
        title: "Грили, контейнеры, термосы MIKU — купить в интернет-магазине",
        description,
        slug: "",
    },
    delivery: {
        title: "Доставка и оплата",
        description,
        slug: "p-dostavka-i-oplata",
    },
    guarantee: {
        title: "Гарантия и возврат",
        description,
        slug: "p-garantiya",
    },
    order: {
        title: "Корзина",
        description,
        slug: "order",
    },
    personal: {
        title: "Личный кабинет",
        description,
        slug: "personal",
    },
    store: {
        title: "Наши магазины",
        description,
        slug: "p-o-magazine",
    },
    madcoins: {
        title: "Бонусная программа",
        description,
        slug: "madcoins",
    },
    status: {
        title: "Проверить статус заказа",
        description,
        slug: "status",
    },
    "online-payment": {
        title: "Онлайн-оплата заказа",
        description,
        slug: "online-payment",
    },
    recipes: {
        title: "Рецепты",
        description,
        slug: "recipes",
    },
    "microwave-kitchen": {
        title: "Грили и контейнеры MIKU для готовки в микроволновой печи — купить в интернет-магазине",
        description:
            "Грили MIKU для жарки мяса, рыбы, овощей в СВЧ. Контейнеры для варки крупы, макарон, пельменей в микроволновой печи. Противни для яичницы, омлета и котлет в СВЧ",
        slug: "microwave-kitchen",
    },
    thermoses: {
        title: "Термосы и термокружки MIKU — купить в интернет-магазине",
        description:
            "Термокувшины и термокружки MIKU с френч-прессом для заваривания чая и кофе. Термосы MIKU для горячих и холодных напитков. Термос для детей",
        slug: "thermoses",
    },
    "document-confidentiality": {
        title: "Политика компании в отношении обработки персональных данных | MIKU",
        description,
        slug: "document-confidentiality",
    },
};
